import { useLayers, useOpenLayersContext } from '@ais-ui/react-openlayers';
import { useEffect, useMemo, useRef } from 'react';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import { useSettings } from '../Settings/SettingsProvider';
import { usePorts } from '../Ports/PortProvider';

export const PortLayer = () => {
  const { addLayer, layers, isCanvasLoaded } = useLayers();
  const { ports } = usePorts();
  const { displayProjection, dataProjection } = useOpenLayersContext();
  const { settings } = useSettings();
  const portsAdded = useRef(false);
  const { shapeToVectorLayer } = useOpenLayersContext();

  const portGeoJson: GeoJson | null = useMemo(() => {
    if (!ports || ports.length === 0) return null;

    return {
      type: 'FeatureCollection',
      properties: {
        id: 'gatehouse-ports',
        name: 'Ports',
        icon: 'port',
        maxZoom: 6,
      },
      features: ports.map((port) => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: port.position.coordinates as number[],
        },
        properties: {
          id: port.id.toString(),
          country: port.country,
          locode: port.locode,
          name: port.name,
          type: 'port',
        },
      })),
    };
  }, [ports]);

  useEffect(() => {
    if (!portGeoJson) {
      return;
    }

    if (!settings['ribbonPlugin.settings']?.show_ports) {
      return;
    }

    if (portsAdded.current) return;

    const portLayer = shapeToVectorLayer(portGeoJson);

    portsAdded.current = true;

    addLayer(
      portLayer,
      'Ports',
      false,
      false,
      false,
      portGeoJson.properties,
      'port',
      false,
      true,  // clickable - for left-click selection
      true,  // hoverEnabled
      'below-ships',  // position
      true   // contextMenuEnabled - for right-click menu
    );
  }, [
    isCanvasLoaded,
    addLayer,
    layers,
    portGeoJson,
    dataProjection,
    shapeToVectorLayer,
    settings,
    displayProjection,
  ]);

  return null;
};
